<template>
  <div class="nebInfoconGroup"
    :class="orientation"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'NebInfoconGroup',

  props: {
    /**
     * Options are [ 'horizontal', 'vertical' ]
     */
    orientation: {
      type: String,
      default: 'horizontal'
    }
  }
}
</script>

<style lang="scss">
@import '../../style.scss';

.nebInfoconGroup {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  &.vertical {
    flex-direction: column;

    .nebInfocon {
      width: 100%;
    }

    .nebInfocon:not(:first-child) {
      padding-top: 7px;
      margin-top: 7px;
      position: relative;

      &::before {
        content: "";
        width: 100%;
        height: 1px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: $warm-grey;
      }
    }
  }

  &.horizontal {
    flex-wrap: wrap;

    .nebInfocon:not(:first-child) {
      padding-left: 7px;
      margin-left: 7px;
      position: relative;

      &::before {
        content: "";
        height: 100%;
        width: 1px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: $warm-grey;
      }
    }
  }
}
</style>
